const $92f841f0d10b5c88$export$1a6cd13aa7443331 = (text)=>{
    if (!text) return text;
    let segments = [];
    const delimiters = " ,.\uFF0C\u3002!?;:\u3001\uFF1B\uFF1A\uFF01\uFF1F\u201C\u201D\u2018\u2019\uFF08\uFF09\u300A\u300B\u3008\u3009\u3010\u3011\u300E\u300F\u300C\u300D\u2026\u2014".split("");
    const candidates = delimiters.map((d)=>({
            delimiter: d,
            index: text.indexOf(d)
        })).filter((d)=>d.index >= 0).sort((a, b)=>a.index < b.index);
    if (candidates.length === 0) return [
        text
    ];
    const segment = text.substring(0, candidates[0].index + 1);
    segments.push(segment);
    const restText = text.substring(candidates[0].index + 1);
    if (restText.length > 0) segments.push(...$92f841f0d10b5c88$export$1a6cd13aa7443331(restText));
    return segments;
};


(()=>{
    const start = document.getElementById("start");
    const stop = document.getElementById("stop");
    const transcriptDiv = document.getElementById("transcript");
    const languageSelector = document.getElementById("language");
    const typewriterDuration = 1000;
    const requireBuffer = false;
    let recorder = null;
    let previousChunk = null;
    let lastChunkRequested = false;
    function renderPage() {
        start.disabled = recorder?.state === "recording";
        stop.disabled = !start.disabled;
    }
    function sleep(interval) {
        return new Promise((res)=>setTimeout(res, interval));
    }
    async function appendTranscript(text, position, conjunctionChar) {
        if (!text || text.length === 0) return;
        if (position && position >= 0) {
            transcriptDiv.innerText = transcriptDiv.innerText.substring(0, position);
            if (transcriptDiv.innerText.length > 0) transcriptDiv.innerText += " ";
        }
        if (transcriptDiv.innerText.length > 0) transcriptDiv.innerText += conjunctionChar ?? " ";
        console.log("splitting text", text);
        const chars = (0, $92f841f0d10b5c88$export$1a6cd13aa7443331)(text);
        if (!chars || chars.length === 0) return;
        const interval = typewriterDuration * 1.0 / chars.length;
        let current = chars.shift();
        while(current){
            await sleep(interval);
            transcriptDiv.innerText += current;
            current = chars.shift();
        }
        transcriptDiv.scrollTop = transcriptDiv.scrollHeight;
    }
    async function uploadAudioFile(filename, blob, prompt, buffered = false) {
        const language = languageSelector.value;
        console.log("transcribing with", language);
        const formData = new FormData();
        formData.append("file", blob, filename);
        formData.append("prompt", prompt);
        if (language !== "auto") formData.append("language", language);
        if (buffered) formData.append("buffered", buffered);
        const { data: data } = await axios.post("https://experiment-stt.empathia.net/transcript/upload", formData, {
            headers: {
                "Content-Type": undefined,
                Accept: "*/*"
            }
        });
        appendTranscript(data.text, data.position, data.conjunctionChar);
    }
    start.addEventListener("click", async ()=>{
        if (transcriptDiv.innerText.length > 0) transcriptDiv.innerText += "\n\n";
        const audioStream = await navigator.mediaDevices.getUserMedia({
            audio: true
        });
        recorder = new MediaRecorder(audioStream);
        let chunks = [];
        const filename = +new Date() + ".webm";
        const headDuration = 5;
        const chunkDuration = 5000;
        let headerChunk = null;
        let startTime = (+new Date()).toString();
        let stopHeadChunk = null, stopPartialChunk = null;
        let chunkId = 0;
        recorder.ondataavailable = async (e)=>{
            if (headerChunk === null) {
                console.log("header chunk set");
                headerChunk = e.data;
                return;
            }
            chunkId++;
            let currentChunks = [
                headerChunk,
                e.data
            ];
            if (requireBuffer && previousChunk) currentChunks.splice(1, 0, previousChunk);
            const audioBlob = new Blob(currentChunks, {
                type: "audio/webm"
            });
            let prompt = transcriptDiv.innerText;
            if (prompt.length === 0) prompt = "Here are the key points for this case, be focus.";
            uploadAudioFile(filename, audioBlob, prompt, requireBuffer);
            previousChunk = e.data;
            if (lastChunkRequested) {
                lastChunkRequested = false;
                previousChunk = null;
            }
        };
        recorder.onstart = (e)=>{
            stopHeadChunk?.();
            stopPartialChunk?.();
            let headChunkTimer = setTimeout(()=>{
                recorder.requestData();
                let partialChunkTimer = setInterval(()=>recorder.requestData(), chunkDuration);
                stopPartialChunk = ()=>{
                    clearInterval?.(partialChunkTimer);
                    stopPartialChunk = null;
                };
            }, headDuration);
            stopHeadChunk = ()=>{
                clearTimeout(headChunkTimer);
                stopHeadChunk = null;
            };
        };
        recorder.onstop = (e)=>{
            stopHeadChunk?.();
            stopPartialChunk?.();
            console.log("recording stopped");
        };
        recorder.start();
        renderPage();
    });
    stop.addEventListener("click", ()=>{
        lastChunkRequested = true;
        recorder.stream.getTracks().forEach((track)=>track.stop());
        recorder.stop();
        renderPage();
    });
    renderPage();
})();


//# sourceMappingURL=index.806a1a44.js.map
